import { cn } from '@repo/tailwind-config/tailwind.functions'
import Typography from '@repo/ui/typography'

import {
  SIDEBAR_WIDTH_CLOSED,
  SIDEBAR_WIDTH_EXPANDED
} from '../../../../../../packages/ui/constants/config'
import PushChevronIcon from '../../../../../../packages/ui/icons/push-chevron'
import { LS_VERSION_KEY } from '../../../api/rest-api-client'
import useSidebarManager from '../../../lib/hooks/use-sidebar-manager'
import SidebarData from './sidebar-data'

type Props = {
  logo: React.ReactNode
  customButton?: React.ReactNode
}

const Sidebar = ({ logo, customButton }: Props) => {
  const { isSidebarExpanded, handleSidebarExpansion } = useSidebarManager()
  const lsVersion = localStorage.getItem(LS_VERSION_KEY)
  return (
    <div
      className={cn('bg-primary py-10 relative h-full duration-300 mobile:hidden tab:hidden', {
        'rounded-3xl': isSidebarExpanded,
        'rounded-2xl': !isSidebarExpanded
      })}
      style={{ width: isSidebarExpanded ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_CLOSED }}
    >
      <div
        className="absolute top-5 -right-4 cursor-pointer bg-white p-2 rounded-sm"
        onClick={() => handleSidebarExpansion(!isSidebarExpanded)}
      >
        <PushChevronIcon
          width="16px"
          height="16px"
          className={cn('fill-primary transition-transform duration-300', {
            'rotate-180': !isSidebarExpanded
          })}
        />
      </div>
      <SidebarData logo={logo} customButton={customButton} />

      <div className="absolute bottom-3 w-full flex justify-center px-2">
        <div
          className={cn('bg-secondary-light rounded transition-all duration-300', {
            'px-3 py-1.5': isSidebarExpanded,
            'px-2 py-1': !isSidebarExpanded
          })}
        >
          <Typography
            variant="label-semibold"
            className={cn('text-secondary whitespace-nowrap', {
              'text-xs': !isSidebarExpanded
            })}
          >
            {isSidebarExpanded ? `Version ${lsVersion}` : lsVersion}
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
